import { axiosInstance } from "../core/http";

export const managerApi = {
  getFullReport: (page = 1) =>
    axiosInstance.get(`/panel/pipe-conflict/full-report/?page=${page}`),
  getStudyFullReport: (page = 1) =>
    axiosInstance.get(`/panel/study/full-report/?page=${page}`),
  updateUserPermissions: (userId, payload) =>
    axiosInstance.put(
      `/panel/conflict-permission/user/${userId}/update/`,
      payload
    ),
  deleteUser: (userId) => axiosInstance.delete(`/panel/user/${userId}/remove/`),
  resetStudyData: (userId) =>
    axiosInstance.delete(`/panel/study/reset/${userId}`),
  getSummary: (userId) =>
    axiosInstance.get(`/panel/pipe-conflict/user/${userId}/report/`),
  getCoachTeams: (userId) =>
    axiosInstance.get(`/api/coach/${userId}/teams/`),
};
